import { useRef, useEffect } from "react";
import { useMapsLibrary } from '@vis.gl/react-google-maps';


// RoutePolyline Component
const RoutePolyline = ({ coordinates, mapInstance }) => {
  const mapsLib = useMapsLibrary("maps");
  const mapsCore = useMapsLibrary("core");
  const polylineRef = useRef(null);
  
  useEffect(() => {
    if (!mapsLib || !mapsCore || !coordinates || coordinates.length < 2) return;
    
    // Clean up previous polyline if it exists
    if (polylineRef.current) {
      polylineRef.current.setMap(null);
    }
    
    const polyline = new mapsLib.Polyline({
      path: coordinates,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 3
    });
    
    polyline.setMap(mapInstance);
    polylineRef.current = polyline;
    
    // Fit bounds to show the entire route
    const bounds = new mapsCore.LatLngBounds()

    coordinates.forEach(coord => {
      bounds.extend({ lat: coord.lat, lng: coord.lng });
    });
    //Not sure if this delay is required
    setTimeout(() => {
      // console.log('Fitting bounds to coordinates');
      mapInstance.fitBounds(bounds);
    }, 100)
    
    
    return () => {
      if (polylineRef.current) {
        polylineRef.current.setMap(null);
      }
    };
  }, [mapsLib, mapsCore, mapInstance, coordinates]);
  
  return null;
};

export default RoutePolyline;